import { EmailAction } from '../types';

/**
 * Ce qu'une action est devenue, au-delà du couple réussi / échoué (S105).
 *
 * Le serveur écrit `success=false` pour deux cas qui ne sont PAS des échecs, et il le
 * fait exprès : la mémoire de fil S82 ne lit que les transferts réussis. Il les
 * distingue par un préfixe stable dans `error_message` :
 *   - `[S102] en pause` : l'agent est en lecture seule, l'action est celle qu'il FERAIT ;
 *   - `[S91] annulé`    : rangement retenu parce qu'aucune notification n'est partie,
 *                         le mail reste visible en boîte, c'est voulu.
 * Les afficher en rouge ferait d'une journée à blanc un mur d'« Error ».
 */
export type EtatAction = 'fait' | 'prevu' | 'annule' | 'echec';

export const PREFIXE_PAUSE = '[S102] en pause';
export const PREFIXE_ANNULATION = '[S91] annul';

export const etatAction = (a: Pick<EmailAction, 'success' | 'error_message'>): EtatAction => {
  if (a.success) return 'fait';
  const m = a.error_message || '';
  if (m.startsWith(PREFIXE_PAUSE)) return 'prevu';
  if (m.startsWith(PREFIXE_ANNULATION)) return 'annule';
  return 'echec';
};

export const STYLE_ETAT: Record<EtatAction, { couleur: string; icone: string; libelle: string; bordure: string }> = {
  fait:   { couleur: '#198754', icone: 'bi-check-circle-fill', libelle: 'Exécutée', bordure: 'border-success' },
  prevu:  { couleur: '#0d6efd', icone: 'bi-pause-circle-fill', libelle: 'Prévue, non exécutée (lecture seule)', bordure: 'border-primary' },
  annule: { couleur: '#6c757d', icone: 'bi-slash-circle', libelle: 'Annulée : le mail reste visible en boîte (S91)', bordure: 'border-secondary' },
  echec:  { couleur: '#dc3545', icone: 'bi-x-circle-fill', libelle: 'Échec', bordure: 'border-danger' },
};

/** Statut d'un mail : un seul échec suffit à le signaler, sinon la pause prime. */
export const etatMail = (actions: Pick<EmailAction, 'success' | 'error_message'>[]): EtatAction => {
  const etats = actions.map(etatAction);
  if (etats.includes('echec')) return 'echec';
  if (etats.includes('prevu')) return 'prevu';
  if (etats.every(e => e === 'fait')) return 'fait';
  return 'annule';
};
